import request from '@/utils/request'


/**
 * 获取角色所有菜单列表
 * @returns {AxiosPromise}
 */
export function getRoleMenusPermissions() {
  return request({
    url: '/auth/menu',
    method: 'get'
  })
}

/**
 * 获取菜单列表
 * @returns {AxiosPromise}
 */
export function getMenus(params) {
  return request({
    url: '/menu/index',
    method: 'get',
    params
  })
}


/**
 * 添加菜单
 * @param data
 * @returns {AxiosPromise}
 */
export function addMenu(data) {
  return request({
    url: '/menu/add',
    method: 'post',
    data
  })
}

/**
 * 编辑菜单
 * @param data
 * @returns {AxiosPromise}
 */
export function editMenu(data) {
  return request({
    url: '/menu/edit',
    method: 'post',
    data
  })
}
//删除菜单
export function delMenu(data) {
  return request({
    url: '/menu/del',
    method: 'post',
    data
  })
}